<!-- tablecollaborator.vue -->

<template>
  <div>
  <Tables ref="tableGridsColaborador"
            :columns="['Nome', 'Função',  'Último lote', 'Início Última Viagem', 'Término Última Viagem', 'Valor Adiantamento','']"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            :newHeaderStatus="true"
            v-on:Load="onLoad">
            <tr v-for="obj in dataCollaborator" :key="obj.id">
               <TableColumn :IsText="obj.dataDemissao == null" :IsTextLocked="obj.dataDemissao !==null" :IsLineThrough="obj.bloqueado" v-on:Edit="redirectToCollaboratorDetails(obj.funcionarioId)" :status="1" :value="obj.nomeFuncionario == null ? 'N/D' : obj.nomeFuncionario" />
               <TableColumn :IsText="obj.dataDemissao == null" :IsTextLocked="obj.dataDemissao !==null" :IsLineThrough="obj.bloqueado" v-on:Edit="redirectToCollaboratorDetails(obj.funcionarioId)" :status="1" :value="obj.cargo == null ? 'N/D' : obj.cargo" />
               <TableColumn :IsText="obj.dataDemissao == null" :IsTextLocked="obj.dataDemissao !==null" :IsLineThrough="obj.bloqueado" v-on:Edit="redirectToCollaboratorDetails(obj.funcionarioId)" :status="1" :value="obj.lote == 0 ? 'N/D' : obj.lote" />
               <TableColumn :IsText="obj.dataDemissao == null" :IsTextLocked="obj.dataDemissao !==null" :IsLineThrough="obj.bloqueado" v-on:Edit="redirectToCollaboratorDetails(obj.funcionarioId)" :status="1" :value="formataData(obj.dataInicio == null ? '-' : obj.dataInicio)" />
               <TableColumn :IsText="obj.dataDemissao == null" :IsTextLocked="obj.dataDemissao !==null" :IsLineThrough="obj.bloqueado" v-on:Edit="redirectToCollaboratorDetails(obj.funcionarioId)" :status="1" :value="formataData(obj.dataFim == null ? '-' : obj.dataFim)" />
               <TableColumn :IsText="obj.dataDemissao == null" :IsTextLocked="obj.dataDemissao !==null" :IsLineThrough="obj.bloqueado" v-on:Edit="redirectToCollaboratorDetails(obj.funcionarioId)" :status="1" :value="formatMoney(obj.valorAdiantamneto == null ? 0 : obj.valorAdiantamneto)" />

                <TableColumn v-if="!isConsulta && hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)"
                  :IsActiveButton="hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)"
                  :newEditGama="hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)"
                  :HasChange="hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)"
                  :IsExpenseTravel="hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)"
                  :IsLockUnlock="hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)"
                  :HasDelete="false"
                  v-on:Delete="openModalDelete(obj)"
                  v-on:Edit="openModalEdit(obj)"
                  v-on:Reinforcement="openModalReinforcement(obj)"
                  v-on:Download="verificacaoArquivoidDomwload(obj)"
                  v-on:Lock="ModalLock(obj)"
                  v-on:DeletePopup="openDeletePopup(obj)"
                  :IsLocked="!obj.bloqueado"
                  :deletePopup="true"
                  />
                  <!-- :IsLocked="verificaBloqueio" -->
                <TableColumn v-else-if="!isConsulta"
                  :newEditGama="true"
                  :HasChange="true"
                  :IsOnlyReinforcement="true"
                  :IsExpenseTravel="true"
                  v-on:Download="verificacaoArquivoidDomwload(obj)"
                  v-on:Delete="openModalDelete(obj)"
                  v-on:Edit="openModalEdit(obj)"
                  v-on:Reinforcement="openModalReinforcement(obj)"
                />
                </tr>
               <template v-if="!isConsulta && hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)" #ButtonsAprova>
                  <div>
                    <button  @click="openModal"  class="btn-head"><i class="fas fa-plus"></i></button>
                  </div>
              </template>
   </Tables>

      <b-modal ref="add-despesa"
      size="md"
      centered
      id="add-brower-modal-conta"
      title="CADASTRAR NOVA DESPESA DIVERSOS"
      :hide-footer="true"
      :clickToClose="false"
      :no-close-on-backdrop="false"
      :no-close-on-esc="false"
      :hide-header-close="true"
      >
      <div class="title-1">Dados Básicos</div>
            <div class="container-user-form">
          <b-form-group
            id="input-group-nome-colaborador"
            label="Nome *"
            label-for="input-nome-colaborador"
            placeholder="Selecione"
          >
          <!-- <autocomplete-z ref="favorecidoTypeaheadPoup"
              placeholder="Digite nome do funcionario"
              iconClass="fas fa-id-badge"
              :serializer="(favorecido) => favorecido.nome"
              :debounceLength="3"
              :formField="formAddDe.objnomeFuncionarios"
              v-on:search="onSearchFavorecido"
              v-on:changeCode="onChangeCodeFavorecido"
              @getInput="getInput"
              v-on:hit="GetCargobyId"
              /> -->
                    <autocomplete-z ref="favorecidoTypeaheadPoup"
              placeholder="Digite nome do funcionario"
              iconClass="fas fa-id-badge"
              :serializer="(favorecido) => favorecido.nome"
              :debounceLength="3"
              :formField="formAddDe.objnomeFuncionarios"
              v-on:search="onSearchFavorecido"
              v-on:changeCode="onChangeCodeFavorecido"
              v-on:hit="GetCargobyId"
              />
          </b-form-group>
         <b-form-group
            id="input-group-funcao"
            label="Função *"
            label-for="input-funcao"
          >
          <div class="input-funcao-cargo" id="cargoSelecionado">
            <b-form-input
                id="input-funcao"
                name="input-funcao"
                type="text"
                placeholder="Função"
                v-model="nomeCargo"
                :disabled="disableDados == true"
              >
              </b-form-input>
          </div>
            <div  class="input-funcao-cargo-bloc" id="cargo">
                        <autocomplete-z ref="favorecidooTypeaheadPoup"
                          placeholder="Digite nome do cargo"
                          :serializer="(cargo) => cargo.nome"
                          :debounceLength="4"
                          :ShowCode="false"
                          :formField="nomeCargo"
                          v-on:search="onSearchCargo"
                          v-on:hit="getcargoId"
                        />
            </div>
         </b-form-group>
         <b-form-group
            id="input-group-valorAdiantamento"
            label="Valor Adiantamento:"
            label-for="input-valorAdiantamento"
          >
          <select class="form-control" v-model="editinfo2.Adiantamento">
            <option :value="null" disabled>{{ 'Selecione um valor de adiantamento' }}</option>
            <option v-for="data in valorAdiantamentoEnum" :key="data.value" :value="data.value">{{data.text}}</option>
          </select>
        </b-form-group>
          <b-form-checkbox
            class="mt-2"
            id="checkbox-1"
            v-model="formAddDe.saldo"
            name="checkbox-1"
            :value="true"
            :unchecked-value="false">
            Possui Saldo Existente?
          </b-form-checkbox>
          <money
            v-if="formAddDe.saldo"
            v-model="formAddDe.saldoValor"
            class="form-control form-control-10"
            v-bind="moneyOpts"
            :placeholder="'0'"
          />
          <b-form-group
          id="input-file-anexo"
          label= "Comprovante de Liberação"
          label-for="input-'file">
            <!-- <div  class="input-file"> -->
              <div v-on:click="addIma" class="input-file">
                  <div class="imp-arquivo">
                    <div>
                      <i class="fas fa-file-import"></i>
                    </div>
                    <div class="title-pdf" v-if="this.arquivocomprovante == null">Adicionar Arquivo</div>
                    <div class="title-pdf" v-else>{{this.arquivocomprovante.data.name}}</div>
                    <!-- <input accept="image/png, image/gif, image/jpeg" type="file" class="addinput" id="input-build"> -->
                    <input accept="image/png, image/gif, image/jpeg" @change="saveBuild" type="file" class="addinput" id="input-build">
                  </div>
            </div>
          </b-form-group>
         <div class="container-buttons-form pt-3">
          <button @click="cancelNewBrower" class="button-cancel">
            Cancelar
          </button>
          <button @click="AdicionarFuncionario(funcionarioId)" class="button-save">Salvar</button>
         </div>
    </div>
   </b-modal>

   <b-modal ref="add-conta"
      size="md"
      centered
      id="add-brower-modal"
      title="CADASTRAR UMA NOVA CONTA"
      :hide-footer="true"
      :clickToClose="false"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="true"
   >
      <div>
        <div class="flex">
         <div class="campo">
            <b-form-group
               id="input-group-name-accountid"
               label="Nome *"
               label-for="input-name-accountid"
            >
            <b-form-input
              id="input-name-accountid"
              name="input-name-accountid"
              type="text"
              v-model="formAddDe.objnomeFuncionarios"
              placeholder="Nome"
            ></b-form-input>
             </b-form-group>
         </div>
            <div class="campo">
               <b-form-group
                  id="input-group-name-accountid"
                  label="Telefone *"
                  label-for="input-name-accountid"
               >
               <b-form-input
               id="input-name-accountid"
               name="input-name-accountid"
               placeholder="Contato"
               v-model="formAddDe.TelefoneCelular"
               v-validate="{ required: true, numeric: false, length:14 }"
               v-mask="['(##) #####-####']"
               ></b-form-input>
               </b-form-group>
            </div>
        </div>

        <div class="flex">
          <div class="campo">
               <b-form-group
                  id="input-group-name-accountid"
                  label="Username *"
                  label-for="input-name-accountid"
               >
                  <b-form-input
                  id="input-name-accountid"
                  name="input-name-accountid"
                  type="text"
                  v-model="formAddDe.Username"
                  placeholder="Username"
                  ></b-form-input>
               </b-form-group>
          </div>
        </div>

                <div class="flex">
            <div class="campo">
               <b-form-group
                  id="input-group-name-accountid"
                  label="Senha *"
                  label-for="input-name-accountid"
               >
                  <b-form-input
                  v-model="formAddDe.Senha"
                  id="input-name-accountid"
                  name="input-name-accountid"
                  type="password"
                  placeholder="Senha"
                  ></b-form-input>
               </b-form-group>
            </div>
            <div class="campo">
               <b-form-group
                     id="input-group-name-accountid"
                     label="Confirmar Senha"
                     label-for="input-name-accountid"
                  >
                     <b-form-input
                     v-model="formAddDe.ConfSenha"
                     id="input-name-accountid"
                     name="input-name-accountid"
                     type="password"
                     placeholder="Confirme a Senha"
                     ></b-form-input>
               </b-form-group>
            </div>
        </div>

        <b-form-group
            id="input-group-name-accountid"
            label="Email *"
            label-for="input-name-accountid"
          >
            <b-form-input
              v-model="formAddDe.Email"
              id="input-name-accountid"
              name="input-name-accountid"
              type="text"
              placeholder="Email"
            ></b-form-input>
        </b-form-group>
    </div>
      <div class="container-buttons-form pt-3">
        <button @click="voltar" class="button-cancel">
          Voltar
        </button>
        <button class="button-save" @click="verificaConfSenha(funcionarioId == null ? formAddDe.funcionarioId :  funcionarioId)">Salvar</button>
      </div>
   </b-modal>

   <b-modal ref="edit-despesa"
      size="lg"
      centered
      id="edit-brower-modal-conta"
      title="EDITAR DESPESA"
      :hide-footer="true"
      :clickToClose="false"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      >
      <div class="columnchamado-edit">
        <div class="edit-text">

          <div>
            <div class="label mb-2">
              Código - Nome
          </div>
            <p class="value">
               {{editinfo.nomeFuncionario}}
            </p>
        </div>
        <div>
          <div class="label mb-2">
              Função
          </div>
          <p class="value">
               {{editinfo.cargo!== null && editinfo.cargo !== undefined ? editinfo.cargo : 'N/D'}}
          </p>
        </div>
        <div>
          <div class="label mb-2">
              Último Lote
          </div>
          <p class="value">
               {{editinfo.lote}}
          </p>
        </div>
        <!-- <div v-if="this.ObjLoteNovoFuncionario.length > 0">
          <div class="label mb-2">
              Primeiro Lote Funcionário
          </div>
          <p class="value">
               {{this.ObjLoteNovoFuncionario[0]}}
          </p>
        </div> -->
        <!-- <div>
          <div class="label mb-2">
              Inicio Última Viagem
          </div>
          <p class="value">
               {{editinfo.dataInicio}}
              </p>
            </div> -->
            <!-- <div class="edit-expense">
              <div class="label mb-2">
                Término Ultima Viagem
              </div>
              <div>
                <p class="value">
                  {{editinfo.dataFinal}}
                </p>
              </div>
            </div> -->
            <b-form-group
            id="input-group-valorAdiantamento"
            label="Valor Adiantamento:"
            label-for="input-valorAdiantamento"
            class="label mb-2"
            >
            <select class="form-control" v-model="editinfo2.AdiantamentoDiversos" >
              <option :value="null">{{ 'Selecione..' }}</option>
              <option v-for="data in valorAdiantamentoEnum" :key="data.value" :value="data.value">{{ data.text }}</option>
            </select>
          </b-form-group>
        </div>
          <div v-on:click="addIma" class="input-file-edit">
            <div class="imp-arquivo">
              <div>
                <i class="fas fa-file-import"></i>
              </div>
              <div class="title-pdf" v-if="this.arquivocomprovante == null">Adicionar Arquivo</div>
              <div class="title-pdf" v-else>{{this.arquivocomprovante.data.name}}</div>
              <!-- <input accept="image/png, image/gif, image/jpeg" type="file" class="addinput" id="input-build"> -->
              <input accept="image/png, image/gif, image/jpeg" @change="saveBuild" type="file" class="addinput" id="input-build">
            </div>
          </div>
      </div>
        <div class="container-buttons-form pt-3">
        <button @click="cancelEditBrower" class="button-cancel">
          Voltar
        </button>
        <button @click="EditaAdiantamento(editinfo.funcionarioId)" class="button-save">Salvar</button>
      </div>
    </b-modal>
    <b-modal ref="reinforcement-despesa"
      size="lg"
      centered
      id="reinforcement-brower-modal-conta"
      title="REFORÇAR DESPESA"
      :hide-footer="true"
      :clickToClose="false"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      >
        <TableReinforcement ref="tableReforco" @editarReforco="openModalReinforcementEdit" @CriaReforco="openModalReinforcementValue" @ArquivoDownload="verificacaoArquivoidDomwloadReforco" :AtualizaReforco="AtualizaReforco" :empresaId="empresareforcoId" :funcionarioId="funcionarioId"></TableReinforcement>
        <div class="container-buttons-form pt-3">
          <button @click="cancelReinforcementBrower" class="button-cancel">
            Voltar
          </button>
        </div>
    </b-modal>
    <b-modal ref="reinforcement-despesa-value"
      size="sm"
      centered
      id="reinforcement-despesa-value-brower-modal"
      title="ADICIONAR REFORÇO DE DESPESA"
      :hide-footer="true"
      :clickToClose="false"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      >
      <div class="columnchamado">
      <div class="label">
        Valor do Reforço
      </div>
      <div class="d-flex largura-reforco">
        <div class="d-flex largura-reforco">
          <money
            v-model="Reforcovalor"
            class="form-control form-control-10"
            v-bind="moneyOpts"
            :placeholder="'0'"
          />
        </div>
      </div>
      </div>
      <div class="ajuste-comprovante-reforço">
        <div class="label">
          Comprovante de Liberação
        </div>
        <b-form-group
        id="input-file-anexo"
        label-for="input-'file">
          <!-- <div  class="input-file"> -->
            <div v-on:click="addIma" class="input-file">
                <div class="imp-arquivo">
                  <div>
                    <i class="fas fa-file-import"></i>
                  </div>
                  <div class="title-pdf" v-if="this.arquivocomprovante == null">Adicionar Arquivo</div>
                  <div class="title-pdf" v-else>{{this.arquivocomprovante.data.name}}</div>
                  <!-- <input accept="image/png, image/gif, image/jpeg" type="file" class="addinput" id="input-build"> -->
                  <input accept="image/png, image/gif, image/jpeg" @change="saveBuild" type="file" class="addinput" id="input-build">
                </div>
          </div>
        </b-form-group>
      </div>
      <div class="container-buttons-form pt-3">
        <button @click="cancelReinforcementValue" class="button-cancel">
            Voltar
          </button>
          <button class="button-save" @click="tableReinforcement">Salvar</button>
      </div>
    </b-modal>
    <b-modal ref="reinforcement-despesa-edit"
      size="sm"
      centered
      id="reinforcement-despesa-edit-brower-modal"
      title="EDITAR REFORÇO DE DESPESA"
      :hide-footer="true"
      :clickToClose="false"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      >
      <div class="columnchamado">
        <div class="d-flex">
          <div class="d-flex">
            <div class="label">
              Valor do Reforço
            </div>
          <money
            v-model="Reforcovalor"
            class="form-control form-control-10"
            v-bind="moneyOpts"
            :placeholder="'0'"
          />
          </div>
        </div>
      </div>
        <div class="ajuste-comprovante-reforço">
        <div class="label">
          Comprovante de Liberação
        </div>
        <b-form-group
        id="input-file-anexo"
        label-for="input-'file">
          <!-- <div  class="input-file"> -->
            <div v-on:click="addIma" class="input-file">
                <div class="imp-arquivo">
                  <div>
                    <i class="fas fa-file-import"></i>
                  </div>
                  <div class="title-pdf" v-if="this.arquivocomprovante == null">Adicionar Arquivo</div>
                  <div class="title-pdf" v-else>{{this.arquivocomprovante.data.name}}</div>
                  <!-- <input accept="image/png, image/gif, image/jpeg" type="file" class="addinput" id="input-build"> -->
                  <input accept="image/png, image/gif, image/jpeg" @change="saveBuild" type="file" class="addinput" id="input-build">
                </div>
          </div>
        </b-form-group>
      </div>

      <div class="container-buttons-form pt-3">
        <button @click="cancelReinforcementEdit" class="button-cancel">
            Voltar
          </button>
          <button class="button-save" @click="EditaReforco">Salvar</button>
      </div>
    </b-modal>
    <b-modal ref="download-despesa"
      size="md"
      centered
      id="download-despesa-brower-modal"
      title="DOWNLOAD COMPROVANTE"
      :hide-footer="true"
      :clickToClose="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      >
      <div class="receipt-download">
        <div class="sub-title">Comprovante</div>

        <div class="comprovante-file">
          <div class="comprovante-footer">{{this.arquivo}}</div>

            <i class="fas fa-file-pdf icone-comprovante" v-if="this.arquivo.includes('.pdf')"></i>
            <img class="image-comprovante" @click="openDetailsimg" v-else :src="'data:image/png;base64,' + this.base64" />

          <div class="download-comprovante" @click="downloadComprovante()"><i class="fas fa-download"></i></div>
        </div>
        <div class="container-buttons-form pt-3">
        <button @click="cancelDownloadBrower" class="button-cancel">
          Voltar
        </button>
      </div>
     </div>
    </b-modal>

    <b-modal ref="download-reforco"
      size="md"
      centered
      id="download-reforco"
      title="DOWNLOAD COMPROVANTE"
      :hide-footer="true"
      :clickToClose="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      >
      <div class="receipt-download">
        <div class="sub-title">Comprovante</div>
{{nameArquivo}}
      <div class="comprovante-file">
          <div class="comprovante-footer">{{this.nameArquivo}}</div>
{{nameArquivo}}
            <i class="fas fa-file-pdf icone-comprovante" v-if="this.arquivo.includes('.pdf')"></i>
            <img class="image-comprovante" @click="openDetailsimg" v-else :src="'data:image/png;base64,' + this.base64" />

          <div class="download-comprovante" @click="downloadComprovante()"><i class="fas fa-download"></i></div>
        </div>
        <div class="container-buttons-form pt-3">
        <button @click="cancelDownloadReforcoBrower" class="button-cancel">
          Voltar
        </button>
      </div>
     </div>
    </b-modal>

    <b-modal ref="Detailsimg" hide-footer hide-header centered size="xl">
            <div v-if="arquivo != null">
                <img class="image-comprovante" v-if="!arquivo.includes('.pdf')" :src="'data:image/png;base64,' + this.base64" />
            <iframe
                    style="overflow: hidden"
                    id="pdfViewer"
                    v-else
                    scrolling="no"
                    class="mb-2 pdf-overview"
                    :src="'data:application/pdf;base64,'+ this.base64 + '#toolbar=0&navpanes=0&scrollbar=0'" frameborder="0">
                  </iframe>
            </div>
    </b-modal>
    <b-modal ref="DetailsLock"
              hide-footer
              centered
              :title="objColaborador.bloqueado == false ? 'BLOQUEAR' : 'DESBLOQUEAR'"
              size="md">
            <div v-if="objColaborador.bloqueado == false">
              <b-form-group
                id="input-lock"
                label="Motivo do bloqueio *"
                label-for="input-input-lock"
              >
                <b-form-textarea
                  v-model="PopupmotivoBloqueio"
                  id="input-motivoBloqueio"
                  name="input-motivoBloqueio"
                  type="text"
                  placeholder="Motivo do bloqueio"
                ></b-form-textarea>
              </b-form-group>
            </div>
            <div v-else>
              <div class="desbloquear">
                <i class="fas fa-unlock icon-unlock"></i>
              </div>
              <div class="font-unlock">Deseja desbloquear esse usuário ?</div>
            </div>
            <div class="container-buttons-form pt-3">
              <button @click="CloseModalLock" class="button-cancel">
                Cancelar
              </button>
              <button @click="LockCollaborator(obj)" class="button-save">Salvar</button>
            </div>
    </b-modal>

    <b-modal
        hide-footer
        centered
        :clickToClose="false"
        size="md"
        ref="add-travel-modal-erro"
        id="add-travel-modal"
        title="Adicionar novo documento">
        <template #modal-header>
            <div class="head-modal-error" v-if="exclusao== false && reforco === false">
                <p id="title-modal-cus" class="erroPoUp">Funcionário Impossibilitado Para Cadastro Temporariamente</p>
            </div>
            <div class="head-modal-error" v-if="exclusao== true && reforco === false">
                <p id="title-modal-cus" class="erroPoUp">Funcionário Impossibilitado Para Exclusão Temporariamente</p>
           </div>
           <div class="head-modal-error" v-if="exclusao== false && reforco === true">
                <p id="title-modal-cus" class="erroPoUp">Funcionário Impossibilitado Para Receber Reforço Temporariamente</p>
            </div>
        </template>
          <div v-if="ArrayFuncionarioImpossibilitado !== 0">
            <div v-if="ArrayFuncionarioImpossibilitado.despesa != null">
              <div class="corpofluxo" v-if="ArrayFuncionarioImpossibilitado.despesa[0].fluxo == 'Reembolso Viagem - Prestação de Conta'">
                   <div class="fluxo_corpo">
                      <div class="fluxo_label_fluxo">
                          {{ArrayFuncionarioImpossibilitado.despesa[0].fluxo}}
                      </div>
                  </div>
                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fa fa-user-circle" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                          Funcionário: {{ArrayFuncionarioImpossibilitado.despesa[0].codigo}} - {{ArrayFuncionarioImpossibilitado.despesa[0].nomeFuncionario}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fas fa-money-check" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                           Valor: {{formatMoney(ArrayFuncionarioImpossibilitado.despesa[0].valorGasto)}}
                      </div>
                  </div>
              </div>
            </div>
            <div v-if="ArrayFuncionarioImpossibilitado.termoAceite != null">
              <div class="corpofluxo"  v-if="ArrayFuncionarioImpossibilitado.termoAceite[0].fluxo == 'Reembolso Viagem - Adiantamento'">
                  <div class="fluxo_corpo" >
                      <div class="fluxo_label_fluxo">
                           {{ArrayFuncionarioImpossibilitado.termoAceite[0].fluxo}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fa fa-user-circle" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                           Funcionário: {{ArrayFuncionarioImpossibilitado.termoAceite[0].codigo}} - {{ArrayFuncionarioImpossibilitado.termoAceite[0].nomeFuncionario}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                         <i class="fas fa-money-check" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                          Valor: {{formatMoney(ArrayFuncionarioImpossibilitado.termoAceite[0].valorGasto)}}
                      </div>
                  </div>
              </div>
            </div>
             <div v-if="ArrayFuncionarioImpossibilitado.despesasDiversos != null">
              <div class="corpofluxo" v-if="ArrayFuncionarioImpossibilitado.despesasDiversos[0].fluxo == 'Despesas Diversos'">
                  <div class="fluxo_corpo">
                      <div class="fluxo_label_fluxo">
                          {{ArrayFuncionarioImpossibilitado.despesasDiversos[0].fluxo}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                         <i class="fa fa-user-circle" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                         Funcionário:{{ArrayFuncionarioImpossibilitado.despesasDiversos[0].codigo}} - {{ArrayFuncionarioImpossibilitado.despesasDiversos[0].nomeFuncionario}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fa fa-money-check" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                          Valor: {{formatMoney(ArrayFuncionarioImpossibilitado.despesasDiversos[0].valorGasto)}}
                      </div>
                  </div>
              </div>
            </div>
            <div v-if="ArrayFuncionarioImpossibilitado.despesasViagem != null">
            <div class="corpofluxo" v-if="ArrayFuncionarioImpossibilitado.despesasViagem[0].fluxo == 'Despesas Viagem'">
                  <div class="fluxo_corpo">
                      <div class="fluxo_label_fluxo">
                          {{ArrayFuncionarioImpossibilitado.despesasViagem[0].fluxo}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fa fa-user-circle" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                         Funcionário: {{ArrayFuncionarioImpossibilitado.despesasViagem[0].nomeFuncionario}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                     <div class="fluxo_icone">
                          <i class="fa fa-money-check" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                          Valor: {{formatMoney(ArrayFuncionarioImpossibilitado.despesasViagem[0].valorGasto)}}
                      </div>
                  </div>
              </div>
            </div>
            <div v-if="ArrayFuncionarioImpossibilitado.saldoPrimeiroAiantamento != null">
            <div class="corpofluxo">
                  <div class="fluxo_corpo">
                      <div class="fluxo_label_fluxo">
                          {{ArrayFuncionarioImpossibilitado.saldoPrimeiroAiantamento[0].fluxo}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                      <div class="fluxo_icone">
                          <i class="fa fa-user-circle" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                         Funcionário: {{ArrayFuncionarioImpossibilitado.saldoPrimeiroAiantamento[0].nomeFuncionario}}
                      </div>
                  </div>

                  <div class="fluxo_corpo">
                     <div class="fluxo_icone">
                          <i class="fa fa-money-check" aria-hidden="true"></i>
                      </div>
                      <div class="fluxo_label">
                          Valor: {{formatMoney(ArrayFuncionarioImpossibilitado.saldoPrimeiroAiantamento[0].valorGasto)}}
                      </div>
                  </div>
              </div>
            </div>
              <div class="fluxo_corpo_aviso">
                  <div class="fluxo_icone_menssagem">
                     <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                  </div>
                  <div class="fluxo_label_menssagem">
                      Por favor regularize a situação do funcionário para criar novas despesas!
                  </div>
              </div>
          </div>
          <div else></div>
        </b-modal>
        <b-modal ref="warning-support"
          class="d-flex"
          size="sm"
          centered
          id="add-brower-modal-warning"
          title="Aviso!"
          :hide-footer="true"
          :clickToClose="false"
          :hide-header-close="true"
          >
          <div class="d-flex flex-column gap-6">
            <div class="d-flex title-1">
              <div class="d-flex flex-column justify-content-center align-items-center mb-2">
                <i class="fa fa-exclamation-triangle mb-2 icon-attention" aria-hidden="true"></i>
                <div class="mb-4 attention-text">Atenção!</div>
                <span>Funcionário sem conta vinculada
                  Contate a equipe de TI</span>
              </div>
            </div>
            <div class="container-buttons-form mt-2">
                <button @click="$refs['warning-support'].hide()" class="button-save">Voltar</button>
            </div>
          </div>
        </b-modal>
        <b-modal ref="delete-despesa"
      size="md"
      centered
      id="delete-despesa-popup-brower-modal"
      title="DELETAR DESPESA"
      :hide-footer="true"
      :clickToClose="false"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      >
      <div class="columnchamado">
        <div class="d-flex warning-delete mb-3">
          <div class="sign mb-2">
            <i class="fa fa-exclamation-triangle" aria-hidden="true" style="color:#008148"></i>
          </div>
          <div class="text-confirm">
            Confirmar Exclusão?
          </div>
        </div>
        <div class="deleteExpense mb-2">
          <div class="travel-dates">
            <div class="w-50">
              <div class="title-delete">Codigo:</div>
              <div>{{ deletingColaborators.codigo }}</div>
            </div>
            <div class="w-50">
              <div class="title-delete">Nome:</div>
              <div>{{ deletingColaborators.nomeFuncionario }}</div>
            </div>
          </div>
          <div class="travel-dates">
            <div class="w-30">
              <div class="title-delete">Função:</div>
              <div>{{ deletingColaborators.cargo }}</div>
            </div>
            <div class="w-30">
              <div class="title-delete">Último Lote:</div>
              <div>{{ deletingColaborators.lote}}</div>
            </div>
            <div class="w-30">
              <div class="title-delete">Valor Adiantamento:</div>
              <div>{{ formatMoney(deletingColaborators.valorAdiantamneto == null ? 0 : deletingColaborators.valorAdiantamneto) }}</div>
            </div>
          </div>
          <div class="travel-dates">
            <div class="w-50">
              <div class="title-delete">Inicio Última Viagem:</div>
              <div>{{ formataData(deletingColaborators.dataInicio) }}</div>
            </div>
            <div class="w-50">
              <div class="title-delete">Término Ultima Viagem:</div>
              <div>{{ formataData(deletingColaborators.dataFim) }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-buttons-form pt-3">
        <button @click="cancelDeletepopup" class="button-no">
            Não
          </button>
          <button class="button-save" @click="ConfirmDelete">Sim</button>
      </div>
    </b-modal>
</div>

</template>

<script>
import tablecollaborator from './tablecollaborator'
export default tablecollaborator
</script>

<style>
  .desbloquear{
    display: flex;
    justify-content: center;
    margin: 1rem;
  }
  .icon-unlock{
    font-size: 50px;
    color: #008144;
  }
  .font-unlock{
    font-size: 16px;
    color: #7c7c7c;
    text-align: center;
  }
  .largura-reforco{
    width: 100%;
  }
  .ajuste-comprovante-reforço{
    margin-top: 1rem;
    padding-bottom: 0.3rem;
  }

  .icon-attention{
    font-size: 60px;
    padding: 1rem;
    color: #008144;
  }
  .attention-text {
    font-size:26px;
    font-weight: bold;
  }
  .head-modal-error{
    display: flex;
    justify-content: center;
  }
  .erroPoUp {
    color: white !important;
    font-size: 16px !important;
    line-height: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .corpofluxo{
    padding: 1rem;
    display: flex;
    background: #dddddd73;
    border-radius: 11px;
    margin-bottom: 1rem;
    gap: 1rem;
    flex-direction: column;
  }
  .fluxo_label_menssagem{
    font-size: 15px;
    font-weight: bold;
  }

  .fluxo_label{
    font-size: 15px;
  }
  .fluxo_label_fluxo{
  font-size: 15px;
  font-weight: bold;
  color: #046437
  }

  .fluxo_icone_menssagem{
    font-size: 25px;
    color: #046437
  }
  .fluxo_icone{
    font-size: 20px;
    width: 2rem;
    color: #046437
  }
  .fluxo_corpo_aviso{
    padding: 1rem;
    align-items: center;
    display: flex;
    justify-content: initial;
    gap: 1rem;
    border: 2px dashed #046437;
  }

  .fluxo_corpo{
    align-items: center;
    display: flex;
    justify-content: initial;
    gap: 1rem;
  }
.display-flax{
  display: flex;
  column-gap: 1rem;
  align-items: center;
  height: 45px;
}
.edit-text {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}

.label{
  font-weight: bold;
}

.columnchamado{
  display: flex;
  flex-direction: column;
}
.columnchamado-edit{
  display: flex;
  justify-content: space-around;
  gap: 1rem;
}
.flex{
   display: flex;
   justify-content: center;
   column-gap: 1rem;
}
.campo{
   width: 100%;
}
.container-buttons-form{
   display: flex;
   justify-content: center;
   column-gap: 1rem;
}
.title-1{
  font-size: 16px;
}
.button-cancel,
.button-save{
   outline: transparent;
   border: transparent;
   border-radius: 4px;
   text-transform: uppercase;
   width: 190px;
   height: 40px;
}
.button-cancel{
   background-color: #dedede;
   color: #747474;
}
.button-save{
   background-color: #008148;
   color: white;
}
.input-funcao-cargo{
  display: none;
}
.input-funcao-cargo-bloc{
  display: block;
}
  .btn-head{
  background-color: #008148;
  color: white;
  border: none;
  width: 3rem;
  font-weight: bold;
  height: 35px;
  font-size: 20px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  }
.container-user-form{
    display: flex;
    column-gap: 10px;
    row-gap: 10px;
    justify-content: center;
    flex-direction:column;
}
.input-file > .imp-arquivo{
  width: 270px;
  background-color: white;
  height: 120px;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  font-size: 30px;
  border: 1px dashed #666;
}

.input-file-edit {
  display: flex;
  align-items: center;
}

.input-file-edit > .imp-arquivo{
  width: 270px;
  background-color: white;
  height: 120px;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  font-size: 30px;
  border: 1px dashed #666;
}

.title-pdf{
  margin-top: 10px;
  font-size: 24px;
  text-align: center;
  word-break: break-word;
}

.addinput{
  height: 100%;
  width: 100%;
  position: absolute;
  visibility: hidden;
}
.input-file{
  display: flex;
  justify-content: center;
}
.sub-title{
    font-size: 16px;
    font-weight: bold;
    color: #008144;
    margin-bottom: 20px;
}
.comprovante-file{
    height: 100%;
    display: flex;
    position: relative;
    justify-content: center;
    cursor: pointer;
    align-items: center;
    width: 275px;
    border: 1px solid rgb(224, 224, 224);
    border-radius: 10px;
}
.icone-comprovante{
    font-size: 60px;
    color: rgb(189, 189, 189);
}
.comprovante-footer{
    width: 100%;
    height: 30px;
    position: absolute;
    font-weight: bold;
    background: rgb(216, 216, 216);
    bottom: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: gray;
    border-radius: 0px 0px 10px 10px;
}
.download-comprovante{
    height: 30px;
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    right: 0px;
    justify-content: center;
    color: white;
    cursor: pointer;
    width: 40px;
    background: #008144;
    border-radius: 0px 10px 0px 10px
}
.image-comprovante{
    height: fit-content;
    width: 100% !important;
    object-fit: contain;
    border-radius: 10px;
}
.receipt-download{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.btn-generate-lote {
   padding: 0 1rem;
   height: 2rem;
   width: 150px;
   background: #008144;
   color: white;
   border-radius: 8px;
   border: none;
   font-weight: bold;
}
.btn-generate-lote:hover{
   background: #024d2a;
}

.deleteExpense{
  display: flex;
  gap: 1.5rem;
  flex-direction: column;
}
.sign{
  font-size: 60px;
}
  .travel-dates{
    display:flex;
    flex-direction: row;
    justify-content: space-between;
  }
.title-delete{
    font-weight: bold;
  }
  .warning-delete {
    align-items: center;
    flex-direction: column;
  }
  .text-confirm {
    font-size: 20px;
  }

  .button-no{
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
    background-color:red;
    color: white;
  }

</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/tablecollaborator/tablecollaborator.vue